import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
const StoreProtectedRoute = () => localStorage.getItem('storeToken') ? <Outlet /> : <Navigate to="/store-login" replace />;
export default StoreProtectedRoute;
